export var Actions;
(function (Actions) {
    /**
     * @description: 跳转学习报告页
     * @param {string|number}reportID 学习报告id
     */
    Actions["jumpStudyReport"] = "jumpStudyReport";
    /**
     * @description: 跳转课后报告详情页
     * @param {string|number}reportID 学习报告id
     */
    Actions["jumpModifyStudyReport"] = "jumpModifyStudyReport";
    /**
     * @description: 跳转试听课测评报告
     * @param {string|number}reportID 报告id
     * @param {string|number}lessonid 课程ID
     */
    Actions["jumpTestReport"] = "jumpTestReport";
    /**
     * @description: 跳转小画家作品秀任务
     * @param {string|number}coinTaskId 报告id
     */
    Actions["jumpWorksShowTask"] = "jumpWorksShowTask";
    /**
     * @description: 小画家作品秀跳转视频详情
     * @param {string}videoId 视频id
     */
    Actions["jumpPainterVideoDetail"] = "jumpPainterVideoDetail";
    /**
     * @description: 跳转我的课表页面
     * @param {object}
     */
    Actions["jumpTimeable"] = "jumpTimeable";
    /**
     * @description 跳转首页
     * @param {object}
     */
    Actions["jumpHome"] = "jumpHome";
    /**
     * @description 跳转上传作品
     * @param {object}
     */
    Actions["jumpWorksWithNative"] = "jumpWorksWithNative";
    /**
     * @description 跳转查看报告
     * @param {object}
     */
    Actions["checkReportWithNative"] = "checkReportWithNative";
    /**
     * @description 发送IM消息
     * @param {object}
     */
    Actions["sendIm"] = "sendIm";
    /**
     * @description 跳转学习详情
     * @param {object}
     */
    Actions["linkStudyDetail"] = "linkStudyDetail";
    /**
     * @description 学习列表
     * @param {object}
     */
    Actions["listStudy"] = "listStudy";
    /**
     * @description 列表检查？
     * @param {object}
     */
    Actions["listCheck"] = "listCheck";
    /**
     * @description 链接检查
     * @param {object}
     */
    Actions["linkCheck"] = "linkCheck";
    /**
     * @description 查看头像
     * @param {object}
     */
    Actions["lookHeaderImg"] = "lookHeaderImg";
    /**
     * @description 列表记录?
     * @param {object}
     */
    Actions["listRecord"] = "listRecord";
    /**
     * @description 列表离开？
     * @param {object}
     */
    Actions["listLeave"] = "listLeave";
    /**
     * @description 出勤记录?
     * @param {object}
     */
    Actions["attendanceRecord"] = "attendanceRecord";
    /**
     * @description 是否展示bar
     * @param {object}
     */
    Actions["showBar"] = "showBar";
    /**
     * @description 是否展示分享按钮
     * @param {number} is_show
     */
    Actions["showShare"] = "showShare";
    /**
     * @description 跳转到客服?
     * @param {object}
     */
    Actions["gotoCustomerService"] = "gotoCustomerService";
    /**
     * @description 下一站？
     * @param {object}
     */
    Actions["nextStation"] = "nextStation";
    /**
     * @description 统计
     * @param {object}
     */
    Actions["web_statistics"] = "web_statistics";
    /**
     * @description 开始加载
     * @param {object}
     */
    Actions["startLoading"] = "startLoading";
    /**
     * @description 保存图片到本地
     * @param {string} imgUrl
     */
    Actions["saveImageCallback"] = "saveImageCallback";
    /**
     * @description 请求强制横屏
     * @param {0|1} isFull
     */
    Actions["fullScreen"] = "fullScreen";
    /**
     * @description 参加人数？
     * @param {object}
     */
    Actions["enterTakeAttendance"] = "enterTakeAttendance";
    /**
     * @description 离开？
     * @param {object}
     */
    Actions["enterTakeOff"] = "enterTakeOff";
    /**
     * @description 关闭页面?
     * @param {object}
     */
    Actions["webClose"] = "webClose";
    /**
     * @description 个人主页？
     * @param {object}
     */
    Actions["enterPersonalHomePage"] = "enterPersonalHomePage";
    /**
     * @description 保存信息?
     * @param {object}
     */
    Actions["saveInfo"] = "saveInfo";
    /**
     * @description 展示APP商城好评
     * @param {object}
     */
    Actions["showAppEvaluateDialog"] = "showAppEvaluateDialog";
    /**
     * @description 关闭webView
     * @param {object}
     */
    Actions["closeWebview"] = "closeWebview";
    /**
     * @description 全屏展示图片
     * @param {any} img 展示图片的索引
     * @param {Array} data 图片列表
     */
    Actions["showFullScreenPicture"] = "showFullScreenPicture";
    /**
     * @description 打开微信首页之后的结果回调
     * @param {object}
     */
    Actions["openWechatCallbacks"] = "openWechatCallbacks";
    /**
     * @description 打开原生视频播放器
     * @param {string | number} videoTotalTime 视频总时长(没有传0)
     * @param {string} videoUrl 视频源 url
     * @param {string} videoTitle 视频标题(没有传"")
     * @param {string | number} videoType 视频类型1：培训视频，2：课件视频，没有传0
     */
    Actions["playVideoWithNative"] = "playVideoWithNative";
    /**
     * 打开原生查看作品集
     * @param index 当前作品集下标
     * @param worksList 所有图片与对应语音文字 ID { id: 作品id, url: 作品集图片地址}
     */
    Actions["showFullScreenWork"] = "showFullScreenWork";
    /**
     * @description 打开原生查看课件图片信息
     * @param {string | number} index: 当前课件图片下标
     * @param {string | number} coursewareList 所有课件列表
     * @param {string | number} coursewareId 当前课件id
     */
    Actions["showCoursePlanWithNative"] = "showCoursePlanWithNative";
    /**
     * @description 打开老师app成长中心，打开成长中心视频
     * @param {string | number} type 1：再看一次，2： 返回列表
     */
    Actions["linkGrowthCenter"] = "linkGrowthCenter";
    /**
     * @description 统计
     * @param {string} event event_name
     * @param attr {key: value}
     */
    Actions["webStatistics"] = "webStatistics";
    /**
     * @description h5页面提交信息后，刷新app入口页面
     * 暂无参数
     * 使用场景（1、课程评价：评价后通知app刷新金币数额，页面按钮状态）
     */
    Actions["refreshClassTable"] = "refreshClassTable";
    /**
     * @description: 原生标题栏右上角文字及跳转链接
     * @param {string|number}title 文字展示
     * @param {string|number}url 跳转链接
     * 使用场景：关注/屏蔽老师列表
     */
    Actions["resetRightButton"] = "resetRightButton";
    /**
     * @description h5页面内有滚动通知app禁止webview容器滚动
     * 暂无参数
     * 使用场景（1、美术报小知识页面内swiper滚动）
     */
    Actions["disPatchTouchViewPager"] = "disPatchTouchViewPager";
    /**
     * @description 老师端H5跳转学习报告修改页面
     * @param { number | string } reportId: 课后报告id
     */
    Actions["jumpTeaModifyStudyReport"] = "jumpTeaModifyStudyReport";
    /**
     * @description 学生端H5跳转学习报告修改页面
     * @param { number | string } reportId: 课后报告id
     * @param { number | string } lessonid: 课程id
     * @param { number | string } worksId: 作品id
     */
    Actions["jumpStuModifyStudyReport"] = "jumpStuModifyStudyReport";
    /**
     * @description H5学习报告分享图片合成1，图1
     * @param { number | string } productImage: 主图
     * @param { number | string } codeImage: 二维码图
     * @param { number | string } textLeftImage: 文字图
     * @param { string } callbackName: 生成之后的回调函数名
     * @param { function } callbackFn: 生成之后的回调执行函数，参数接收原生端返回base64图片数据
     */
    Actions["syntheticProductImage"] = "syntheticProductImage";
    /**
     * @description H5学习报告详情右上角分享按钮显示，调就显示，不调不显示
     * @param { string } callbackName: 注册原生的js函数名的回调函数名
     * @param { function } callbackFn: 点击分享按钮触发的js函数
     */
    Actions["showProductShare"] = "showProductShare";
    /**
     * @description学生端跳转个人作品页面
     * @param 暂无
     */
    Actions["jumpToUserHome"] = "jumpToUserHome";
    /**
     * @description 学生端升级APP
     * @param 暂无
     */
    Actions["versionUpgrade"] = "versionUpgrade";
    /**
     * @description: 小画家作品秀微信分享
     * @param {object}
     */
    Actions["shareToWeChat"] = "shareToWeChat";
    /**
     * @description 学生端跳转登录页面
     * @param { string } callbackName: 生成之后的回调函数名
     * @param { function } callbackFn: 生成之后的回调执行函数，参数接收原生端返回用户id数据，{userId: xxx}
     */
    Actions["gotoLogin"] = "gotoLogin";
    /**
     * @description H5学习报告分享图片合成2，图2
     * @param { string } headerUrl 学生头像
     * @param { string } qrCodeUrl 二维码链接
     * @param { string } nickname 学员昵称
     * @param { string } workNum 作品数量
     * @param { number | string } productImage: 主图
     * @param { number | string } textLeftImage: 文字图
     * @param { string } callbackName: 生成之后的回调函数名
     * @param { function } callbackFn: 生成之后的回调执行函数，参数接收原生端返回base64图片数据
     */
    Actions["syntheticPosterProductImage"] = "syntheticPosterProductImage";
    /**
     * @description 分享外部链接
     * @param { string } shareTitle 分享标题
     * @param { string } shareText 分享文本
     * @param { string } shareLinkString 分享链接
     * @param { string } shareImage 分享图片
     */
    Actions["outterLinkShare"] = "outterLinkShare";
    Actions["shareFaceBook"] = "shareFaceBook";
    /**
     * @description 跳转到APP已上课程页面
     */
    Actions["jumpToAlreadyTimeTable"] = "jumpToAlreadyTimeTable";
    /**
     * @description 老师简历调用原生视频播放
     * @param { string } teacherName 老师名
     * @param { string } parentEvaluate 家长评价
     * @param { string } classAttendance 到课率
     */
    Actions["playTeacherResumeWithNative"] = "playTeacherResumeWithNative";
    /**
     * @description 重置关闭按钮 app点击返回直接关闭webview
     * @param { string } resetIcon yes 重置icon为×
     */
    Actions["resetBackActionToCloseWebView"] = "resetBackActionToCloseWebView";
    /**
     * @description 分享小程序
     * @param { string } title 分享标题
     * @param { string } img 分享icon
     * @param { string } url 分享url
     * @param { string } source_id 分享url
     */
    Actions["webShareApplets"] = "webShareApplets";
    /**
     * @description 跳转广场
     * @param {object}
     */
    Actions["jumpWorkSquare"] = "jumpWorkSquare";
    /**
     * @description 跳转首页
     * @param {object}
     */
    Actions["jumpNewHome"] = "jumpNewHome";
    /**
     * @description 跳转游戏页面
     * @param { url } url 跳转地址
     */
    Actions["openCocosWebView"] = "openCocosWebView";
    /**
     * @description 修改简历上传vlog选封面
     * @param { string } callbackName: 生成之后的回调函数名
     * @param { function } callbackFn: 生成之后的回调执行函数，参数接收原生端返回视频（videoUrl）、封面（vlogCover）和状态码（0成功 1失败）
     */
    Actions["teacherResumeUpload"] = "teacherResumeUpload";
    /**
     * @description 安卓吊起相册选视频
     * @param { string } callbackName: 生成之后的回调函数名
     * @param { function } callbackFn: 生成之后的回调执行函数，参数接收原生端返回视频（videoUrl）和状态码（0成功 1失败）
     */
    Actions["teacherClassRoomUpload"] = "teacherClassRoomUpload";
    /**
     * @description 新版课后报告老师点评作品
     * @param { number } lessionId 课程id
     * @param { string } topicTitle 知识点标签
     */
    Actions["jumpWorkComment"] = "jumpWorkComment";
    /**
     * @description 跳转IM对话框
     * @param { number } headTeacherId 班主任id
     * @param { string } conversationType 会话类型 1 群聊 2 单聊
     */
    Actions["jumpToHeadTeacherConversationVC"] = "jumpToHeadTeacherConversationVC";
    /**
     * @description 跳转待上课程并弹出窗
     * @param { Array } conditions 弹窗条件
     * @param { number } autoSuccess //1为自动 0为手动
     */
    Actions["appointCourseSuccess"] = "appointCourseSuccess";
    /**
     * @description 跳转待上课程
     * @param { * }
     */
    Actions["makeUpMissedLessonsSuccess"] = "makeUpMissedLessonsSuccess";
    /**
     * @description 登陆并领取课程
     */
    Actions["paintSubjectLogin"] = "paintSubjectLogin";
    /**
     * @description 客户端绑定邮箱
     */
    Actions["bindEmail"] = "bindEmail";
    /**
     * @description 美育课兑换确认
     */
    Actions["eduClassExchange"] = "eduClassExchange";
    /**
     * @description 上传图片 - 可定宽高裁剪
     * @param { string } width 图片宽度
     * @param { string } height 图片高度
     * @param { string } callbackName: 生成之后的回调函数名
     * @param { function } callbackFn: 生成之后的回调执行函数，参数接收原生端返回base64图片数据
     */
    Actions["gradingSelectAvatar"] = "gradingSelectAvatar";
    /**
     * @description 上传作品
     * @param { string } callbackName: 生成之后的回调函数名
     * @param { function } callbackFn: 生成之后的回调执行函数，参数接收原生端返回base64图片数据
     */
    Actions["gradingSelectOpus"] = "gradingSelectOpus";
    /**
     * @description 打开弹窗协议
     * @param {string} url 协议链接
     */
    Actions["pushDetailController"] = "pushDetailController";
    /**
     * @description 分享微博
     * @param { string } desc: 文字部分
     * @param { string } url: 链接地址
     * @param { string } imgUrl: 图片地址
     */
    Actions["shareWeiBo"] = "shareWeiBo";
    /**
     * @description 分享Messenger
     * @param { string } desc: 文字部分
     * @param { string } url: 链接地址
     */
    Actions["shareMessenger"] = "shareMessenger";
    /**
     * @description 分享Whatsapp
     * @param { string } desc: 文字部分
     * @param { string } url: 链接地址
     */
    Actions["shareWhatsapp"] = "shareWhatsapp";
    /**
     * @description 分享 更多
     * @param { string } desc: 文字部分
     * @param { string } url: 链接地址
     */
    Actions["shareGetMore"] = "shareGetMore";
    /**
     * @description 关闭APP
     */
    Actions["appExit"] = "appExit";
    /**
     * @description 声明签约确认
     * @param { string } guardianName:父母名字
     * @param { string } childName: 孩子名字
     */
    Actions["gainGuardianinfo"] = "gainGuardianinfo";
    /**
     * @description: 调用APP智齿客服
     */
    Actions["openSobotChatVC"] = "openSobotChatVC";
    /**
     * @description 上传作品(新) 限定大小 1M<work<20M
     * @param { string } callbackName: 生成之后的回调函数名
     * @param { function } callbackFn: 生成之后的回调执行函数，参数接收原生端返回base64图片数据
     */
    Actions["gradingSelectWork"] = "gradingSelectWork";
    /**
     * @description 修改APP左上角返回按钮控制 （暂未生效，先保留）
     * @param { string } callbackName: 生成之后的回调函数名
     * @param { function } callbackFn: 生成之后的回调执行函数
     */
    Actions["setControlBack"] = "setControlBack";
    /**
     * @description 进入教室
     * @param { string } lessonId: 课程id
     * @param { roomid } lessonId: 教室id
     */
    Actions["showLive"] = "showLive";
    /**
     * @description 检查录音权限
     */
    Actions["requestAudioAuthorization"] = "requestAudioAuthorization";
    /**
     * @description 开始录音
     */
    Actions["startRecordAudio"] = "startRecordAudio";
    /**
     * @description 结束录音权限
     */
    Actions["stopRecordAudio"] = "stopRecordAudio";
    /**
     * @description 上传曲谱
     */
    Actions["liveroomUploadScore"] = "liveroomUploadScore";
    /**
     * @description 注销
     */
    Actions["appReset"] = "appReset";
    /**
     * @description 下载隐私协议
     */
    Actions["downloadPrivacy"] = "downloadPrivacy";
})(Actions || (Actions = {}));
//# sourceMappingURL=action.js.map